import type { Screen } from './routes';

/**
 * A screen that exists in the route tree but whose surface lands in a later
 * sprint.
 *
 * It shows the traceability ID and says plainly that nothing is built yet. It
 * does NOT show sample content: the founder ruling is that no fabricated
 * property, obligation or figure appears on any surface a user reaches, and a
 * plausible-looking mock is the most persuasive kind of fabrication. An empty
 * state that says "not built" cannot be mistaken for data.
 */
export function Placeholder({ screen, notFound }: { screen?: Screen; notFound?: boolean }) {
  if (notFound) {
    return (
      <section>
        <h1>Not found</h1>
        <p>No screen is mapped to this address.</p>
      </section>
    );
  }
  return (
    <section data-screen={screen!.id}>
      <h1>{screen!.label}</h1>
      <p>
        <code>{screen!.id}</code> — route wired, surface not yet built.
      </p>
    </section>
  );
}
